import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

interface IGrpcResponseWithPaging {
  pagingInfo?: racehorse360.IPagingInfo;
}

export const getChunksFromResponse = <T>(array: T[], pageSize = 5): T[][] => {
  const chunks: T[][] = [];

  for (let i = 0; i < array.length; i += pageSize) {
    chunks.push(array.slice(i, i + pageSize));
  }

  return chunks;
};

export const getTotalResultsFromData = (
  data: Partial<Omit<IGrpcResponseWithPaging, "toJSON">>,
  defaultValue = 0
): number => {
  return data?.pagingInfo?.totalResults ?? defaultValue;
};
